import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import {
  ActivatedRouteSnapshot,
  CanActivate,
  RouterStateSnapshot,
} from '@angular/router'
import { Observable } from 'rxjs/Observable'
@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): any {
    if (localStorage.getItem('adminInfo')) {
      return true
    } else {
      this.router.navigate(['/'])
      return false
    }
  }
}
